import { appConfig } from 'config/app';
import {
  IAuthMFARequired,
  IAuthRequest,
  IAuthResendVerificationCode,
  IAuthToken,
  IForgotPasswordRequest,
  IForgotPasswordVerifyRequest,
  IForgotPasswordVerifyToken,
  IGoogleUser,
  IGoogleUserRequest,
  IIdentity,
  IResetPassword,
  IResetPasswordRequest,
} from 'types';
import { ApiClient } from './ApiClient';

export const Authentication = {
  login: (body: IAuthRequest) => ApiClient.post<IAuthToken | IAuthMFARequired>(`${appConfig.API_BASE_URL}/v1/auth`, body),
  loginMFAVerify: (authId: string, code: string) => ApiClient.put<IAuthToken>(`${appConfig.API_BASE_URL}/v1/auth/${authId}/verify`, { code }),
  resendCodeMFA: (authId: string, channel?: string) => ApiClient.put<IAuthResendVerificationCode>(`${appConfig.API_BASE_URL}/v1/auth/${authId}/resend`, { ...(channel && { channel }) }),
  forgotPassword: (body: IForgotPasswordRequest) => ApiClient.post<IIdentity>(`${appConfig.API_BASE_URL}/v1/forgot_password`, body),
  forgotPasswordVerify: (identityId: string, body: IForgotPasswordVerifyRequest) => ApiClient.post<IForgotPasswordVerifyToken>(`${appConfig.API_BASE_URL}/v1/forgot_password/${identityId}/verify`, body),
  resetPassword: (identityId: string, body: IResetPasswordRequest) => ApiClient.put<IResetPassword>(`${appConfig.API_BASE_URL}/v1/reset_password/${identityId}`, body),
  getGoogleUser: (body: IGoogleUserRequest) => ApiClient.post<IGoogleUser>(`${appConfig.API_BASE_URL}/v1/auth/google`, body),
};
